import { render, staticRenderFns } from "./ProceQuestionEdit.vue?vue&type=template&id=3abe157b&scoped=true&"
import script from "./ProceQuestionEdit.vue?vue&type=script&lang=js&"
export * from "./ProceQuestionEdit.vue?vue&type=script&lang=js&"
import style0 from "./ProceQuestionEdit.vue?vue&type=style&index=0&id=3abe157b&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3abe157b",
  null
  
)

component.options.__file = "ProceQuestionEdit.vue"
export default component.exports